import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import moment from 'moment';
import {formatMoney, camelize} from 'core/utils';
import {reverse} from 'core/urls';
import KeyValueList from 'components/key-value-list';
import Button from 'components/button';
import styles from './styles.css';

@autobind
export default class OrderHeader extends Component {
    static propTypes = {
        order: PropTypes.object.isRequired,
        showStatus: PropTypes.bool.isRequired,
        isModifying: PropTypes.bool,
    }

    getModifyUrl(order) {
        return reverse(camelize([...order.category.id.split('_'), 'modify']), {id: order.id});
    }
    render() {
        const {order, showStatus} = this.props;
        return (
            <div className={styles.root}>
                <div className={styles.title}>
                    <div className={styles.orderNumber}>
                        <i className={styles.boxIcon} />
                        {this.props.isModifying && 'Modificar: '}
                        Pedido #{order.id}
                    </div>
                    {order.isModifiable && !this.props.isModifying && (
                        <Button
                            className={styles.modifyOrder}
                            link={this.getModifyUrl(order)}
                            theme='yellow'>
                                MODIFICAR PEDIDO
                        </Button>
                    )}
                </div>
                <div className={styles.orderInfo}>
                    <KeyValueList
                        data={order}
                        rows={[
                            {
                                key: 'created',
                                label: 'Fecha',
                                format: value => moment(value).format('LLL'),
                            },
                            (order.createdBy) && {
                                key: 'createdBy',
                                label: 'Realizado por',
                                format: ({firstName, lastName, email}) => `${firstName} ${lastName} - ${email}`,
                            },
                            {
                                key: 'organization.name',
                                label: 'Organización',
                            },
                            {
                                key: 'organization.cuit',
                                label: 'CUIT de la organización',
                            },
                            {
                                key: 'category.name',
                                label: 'Tipo',
                            },
                            (showStatus) && {
                                key: 'status.name',
                                label: 'Estado',
                            },
                            (order.total > 0) && {
                                value: formatMoney(order, 'total'),
                                label: 'Costo total',
                            },
                            (order.shippingAddress) && {
                                key: 'shippingAddress',
                                label: 'Dirección de envío',
                                format: ({street, postalCode, locality, phone, notes}) => {
                                    return [street, postalCode, locality.label, phone, notes]
                                        .filter(Boolean)
                                        .join(', ');
                                },
                            },
                            (order.refund && order.refund.estimatedAmount) && {
                                label: 'Presupuesto estimado',
                                value: formatMoney(order.refund, 'estimatedAmount'),
                            },
                            (order.refund && order.refund.confirmedAmount) && {
                                label: 'Presupuesto confirmado',
                                value: formatMoney(order.refund, 'confirmedAmount'),
                            },
                        ]}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/order-header/index.js